<template>
    <div class="row shops__list">
        <shop-item v-for="(market, index) in markets" :key="index" :market="market" :mainlng="mainlng"
                   :lng="lng"></shop-item>
    </div>
</template>

<script>
export default {
    name: "ShopList",
    props: {
        markets: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
    },
    data() {
        return {}
    },
    methods: {},
    computed: {},
    mounted() {

    }
}
</script>

<style scoped>

</style>
